import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class IwahTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);

  updateTitle(snapshot: RouterStateSnapshot): void {
    const activeTab = this.getDataFromAppRoute(snapshot.root, 'tab');
    const appTitle = 'Integration and Workload Automation Hub';

    if (activeTab) {
      this.titleService.setTitle(`${activeTab} | ${appTitle}`);
    } else {
      this.titleService.setTitle(`Page Not Found | ${appTitle}`);
    }
  }

  private getDataFromAppRoute(route: ActivatedRouteSnapshot | null, key: string): string | undefined {
    while (route) {
      if (route.data[key]) {
        return route.data[key] as string;
      }
      route = route.firstChild;
    }
    return undefined;
  }
}
